<div>
    <span *ngIf="description" [innerHtml]="description" data-e2e-id="description">{{
        description
    }}</span>
</div>
<mat-dialog-actions>
    <button data-e2e-id="btn-cancel" mat-button type="button" color="primary" (click)="onCancel()">
        {{ cancelButtonText }}
    </button>
    <button
        data-e2e-id="btn-save"
        mat-flat-button
        primaryButton
        type="submit"
        (click)="onConfirm()"
    >
        {{ confirmButtonText }}
    </button>
</mat-dialog-actions>
